module.exports = {
      id: "Check_Default-usage",
      viewBox: "0 0 11 10",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Check_Default-usage",
      toString: function () {
        return this.url;
      }
    }